import config from "../config";
import {dictionary} from "../constants"
import {Util} from "baziigram"

export default client => {
    function call(groupName,gameId,pageNumber,pageSize , offline) {
        let body = {
            groupName,gameId,pageNumber,pageSize,offline
        };

        return client.post(config.app.service.apiUrls.GetChats, body).then(resp => {
            if (resp.status && (resp.status === 200 || resp.status === 204))
                return resp.data;

            throw new Error(resp.message || dictionary.serverError[Util.getLanguage()]);
        });
    }

    return call;
};
